/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Windows_4Inputs */

const en_pc_dl_windows_4 = /** @type {(inputs: Pc_Dl_Windows_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No admin rights? Use the portable .zip. It runs from any folder, even a USB stick, and keeps its settings next to pdfcraft.exe.`)
};

const zh_pc_dl_windows_4 = /** @type {(inputs: Pc_Dl_Windows_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有管理员权限？使用便携版 .zip。它可在任意文件夹（甚至 U 盘）中运行，设置保存在 pdfcraft.exe 旁边。`)
};

/**
* | output |
* | --- |
* | "No admin rights? Use the portable .zip. It runs from any folder, even a USB stick, and keeps its settings next to pdfcraft.exe." |
*
* @param {Pc_Dl_Windows_4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_windows_4 = /** @type {((inputs?: Pc_Dl_Windows_4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Windows_4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_windows_4(inputs)
	return zh_pc_dl_windows_4(inputs)
});
export { pc_dl_windows_4 as "pc.dl.windows.4" }